<template>
  <div class="listbox">
    <p
      v-for="city in searchListContent"
      :key="city.id"
      class="city-search-item"
      @click="changeCity(city)"
    >{{ city.name }}</p>
  </div>
</template>

<script setup>
defineOptions({name: 'CityItem'});

defineProps({
  searchListContent: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['changeName']);

function changeCity (city) {
  emit('changeName', city);
}
</script>

<style lang="stylus" scoped>
.listbox
  width 100%
  background var(--surface-bg)
  .city-search-item
    background var(--surface-bg)
    color var(--text-normal)
    margin 0px 10px
    height 35px
    line-height 35px
    border-bottom 1px solid var(--border-color)
    box-sizing border-box
  .city-item:last-child
    border none
</style>
